import React from 'react';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import { Category1TypeFields, Category1Types } from 'enums/category1Enums';
import { Category9Types } from 'enums/Scope3category9Enums';
import { addProductTitle } from 'constants/constants';
import ErrorIcon from 'views/ActivityDataEntry/ScopeUpstreamList/CategoryOneComponent/ErrorIcon';
import Catgeory4Layout from './Category4Layout/category4Layout';
import FinishedGoods from './FinishedGoodsLayout/finishedGoods';
import styles from './category4and9.module.scss';
import { FieldArrayWithId, UseFieldArrayRemove } from 'react-hook-form';
import { Category4 } from 'models/Scope3/category4.model';
import { Supplier } from 'models/Supplier/Supplier.model';

interface GeneratePanelListProps {
  ingredientFields: FieldArrayWithId<Category4, 'ingredients', 'id'>[];
  packagingFields: FieldArrayWithId<Category4, 'packagings', 'id'>[];
  otherFields: FieldArrayWithId<Category4, 'others', 'id'>[];
  finishedGoodsFields: FieldArrayWithId<
    Category4,
    'finishedGoods.products',
    'id'
  >[];
  categoryError: String[];
  supplierList: Supplier[];
  fetchSuppliers: (params?: {
    page?: number;
    size?: number;
    name?: string;
  }) => Promise<void>;
  addProduct: React.MouseEventHandler;
  remove: UseFieldArrayRemove;
}

export const generatePanelList = ({
  ingredientFields,
  packagingFields,
  otherFields,
  finishedGoodsFields,
  categoryError,
  supplierList,
  fetchSuppliers,
  addProduct,
  remove,
}: GeneratePanelListProps) => [
  ...(ingredientFields?.length
    ? [
        {
          key: Category1TypeFields.INGREDIENTS,
          header: (
            <div>
              <span>
                Ingredients
                <ErrorIcon
                  errorList={categoryError}
                  stringToCheck={Category1Types.INGREDIENTS}
                />
              </span>
            </div>
          ),
          content: ingredientFields?.map((field, index) => (
            <Catgeory4Layout
              type={Category1Types.INGREDIENTS}
              index={index}
              key={field?.id}
              item={field}
              supplierList={supplierList}
              fetchSuppliers={fetchSuppliers}
            />
          )),
        },
      ]
    : []),
  ...(packagingFields?.length
    ? [
        {
          key: Category1TypeFields.PACKAGING_MATERIALS,
          header: (
            <div>
              <span>
                Packaging Material
                <ErrorIcon
                  errorList={categoryError}
                  stringToCheck={Category1Types.PACKAGING_MATERIALS}
                />
              </span>
            </div>
          ),
          content: packagingFields?.map((field, index) => (
            <Catgeory4Layout
              type={Category1Types.PACKAGING_MATERIALS}
              index={index}
              key={field?.id}
              item={field}
              supplierList={supplierList}
              fetchSuppliers={fetchSuppliers}
            />
          )),
        },
      ]
    : []),
  ...(otherFields?.length
    ? [
        {
          key: Category1TypeFields.OTHERS,
          header: (
            <div>
              <span>
                Others
                <ErrorIcon
                  errorList={categoryError}
                  stringToCheck={Category1Types.OTHERS}
                />
              </span>
            </div>
          ),
          content: otherFields?.map((field, index) => (
            <Catgeory4Layout
              type={Category1Types.OTHERS}
              index={index}
              key={field?.id}
              item={field}
              supplierList={supplierList}
              fetchSuppliers={fetchSuppliers}
            />
          )),
        },
      ]
    : []),
  {
    key: 'finishedGoods.products',
    header: (
      <div>
        <div>
          Finished Goods
          <ErrorIcon
            errorList={categoryError}
            stringToCheck={Category9Types.FINISHED_GOODS}
          />
        </div>
        <div className={styles.addAction} onClick={addProduct}>
          <div className={styles.addButton}>
            <AddIcon />
            {addProductTitle}
          </div>
        </div>
      </div>
    ),
    content: (
      <div className={styles.finishedGoodsWrapper}>
        <div className={styles.finishedGoodsContent}>
          <FinishedGoods fields={finishedGoodsFields} remove={remove} />
        </div>
      </div>
    ),
  },
];
